import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_fa--sm _ttu _flex _ai-c _tac" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_performance_marketing_badge_box = _resolveComponent("performance-marketing-badge-box")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    to: $props.route,
    enabled: !!$props.route,
    theme: "disable-word-break"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_performance_marketing_badge_box, { class: "_w-min _flexcol _gap-1 _jc-c _ai-c" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon, {
            name: $props.iconName,
            size: "lg",
            class: "_tc--accent"
          }, null, 8 /* PROPS */, ["name"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("b", null, _toDisplayString($props.label), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to", "enabled"]))
}